module.exports = __webpack_public_path__ + "img/icon-discount.c36e8f20.svg";